import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import Modal from 'components/organisms/NewModal';
import FilterCollection from 'components/organisms/FilterCollection';

const useStyles = makeStyles((theme) => ({
  modalWrap: {
    '& > div, & > p': {
      marginBottom: 10,
    },
  },
  modalBtn: {
    width: '100%',
    border: 'none',
    opacity: 0.8,
    backgroundColor: theme.palette.common.gray2,
    '&:hover': {
      opacity: 1,
    },
  },
  approval: {
    '&:hover, &.active': {
      backgroundColor: '#8ce3c3',
    },
  },
  return: {
    '&:hover, &.active': {
      backgroundColor: '#fa6a6a',
    },
  },
}));

const ChangeState = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    adGrpRsnCodeList,
    error,
    modal,
    getParams = (f) => f,
    handleStatus = (f) => f,
    handleModalClose = (f) => f,
  } = props;

  let initStatus = !!modal.data
    ? modal.data['AD_GRP_STATE_STR'] === '반려'
      ? '99'
      : modal.data['AD_GRP_STATE_STR'] === '승인'
      ? '02'
      : null
    : null;
  const [status, setStatus] = useState(initStatus);

  useEffect(() => {
    setStatus(initStatus);
  }, [modal.data, initStatus]);

  const handleClose = () => {
    handleModalClose();
    setStatus(null);
  };

  return (
    <Modal
      open={modal.open}
      headerTitle={t('검수 상태 변경')}
      handleClose={handleClose}
      confirmOnClick={() => handleStatus(status)}
      style={{ minWidth: 550 }}
    >
      <div className={classes.modalWrap}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <NewButton
            title={t('반려')}
            onClick={() => setStatus('99')}
            className={clsx(
              classes.modalBtn,
              classes.return,
              status === '99' ? 'active' : null
            )}
            disableRipple
            boxStyle={{ width: '48%' }}
          >
            {t('반려')}
          </NewButton>
          <NewButton
            title={t('승인')}
            onClick={() => {
              let newParams = { ...modal.params };
              setStatus('02');
              delete newParams['adGrpRsnCode'];
              delete newParams['comment'];
              getParams(newParams);
            }}
            className={clsx(
              classes.modalBtn,
              classes.approval,
              status === '02' ? 'active' : null
            )}
            disableRipple
            boxStyle={{ width: '48%' }}
          >
            {t('승인')}
          </NewButton>
        </div>
        <FilterCollection
          label={t('사유선택')}
          value={modal.params.adGrpRsnCode}
          name="adGrpRsnCode"
          type="select"
          params={modal.params}
          list={adGrpRsnCodeList}
          labelKey="label"
          valueKey="value"
          callBack={getParams}
          error={error.adGrpStateCode}
          disabled={status === '02'}
        />
        <NewInput
          label={t('상세사유')}
          name="comment"
          value={modal.params.comment}
          params={modal.params}
          callBack={getParams}
          style={{ width: '100%', maxWidth: 'none' }}
          multiline
          rows={3}
          error={error.comment}
          disabled={status === '02'}
        />
      </div>
    </Modal>
  );
};

export default ChangeState;
